import Vue from 'vue';
import axios from 'axios';
import md5 from 'md5';
import { Agent } from 'https'
import { getServiceType } from 'src/utils/common';
import { WEB_HOOK } from 'src/utils/config';
import { getServerBaseURL } from '../utils/base';
import { pushLog } from '../utils/pushLog'

// eslint-disable-next-line import/no-mutable-exports
let request;
const baseURL = getServerBaseURL('ofbiz');
const IS_PROD = process.env.ENV === 'production';


const boot = ({ store, router, ssrContext }) => {
  const lang = ssrContext?.req?.headers?.cookie?.match(/BUYER_LANG=([a-z]{2}-[A-Z]{2})/)?.[1];
  const service = axios.create({
    httpsAgent: new Agent({ rejectUnauthorized: false }),
    baseURL,
    withCredentials: true, // send cookies when cross-domain requests
  });

  service.interceptors.request.use(
    config => {
      config.headers.app = 'MenuBuyer';
      config.headers['local-agent'] = 'DestyMenuSeller';
      config.responseKey = md5(`${+new Date()}${Math.random() * 999999999}`);
      const { language } = store.state.Menu;
      let { token } = store.state.Menu;
      if (process.env.CLIENT) {
        token = token || localStorage.getItem('token')
      }
      if (token) {
        config.headers.Authentication = token;
        config.headers.token = token;
      }
      if (!config.noAddStroreName) {
        const storeName = router.currentRoute.params.store;
        config.url = `/${storeName}${config.url}`;
      }
      const serviceType = getServiceType();
      if (serviceType) {
        config.headers.serviceType = serviceType;
      }

      config.headers.Language = language || lang || 'id-ID';
      return config;
    },
    error => Promise.reject(error),
  );

  service.interceptors.response.use(
    response => {
      if (response.status === 200) {
        const token = response.headers['new-token'];
        if (process.env.CLIENT) token && localStorage.setItem('token', token);
        if (response.data) response.data.success = response.data.code === 200
        return response.data;
      }
      return response;
    },
    error => {
      pushLog({
        key: 'axios response error',
        status: error.response?.status || '未知',
        responseKey: error.response?.config?.responseKey,
        response: JSON.stringify(error.response?.data),
        reqdata: JSON.stringify(error.response?.config?.data),
        params: JSON.stringify(error.response?.config.params),
        url: error.response?.config?.url
      });
      if (error.response) {
        if (error.response.status === 401) {
          if (process.env.CLIENT) {
            localStorage.removeItem('token');
            store.dispatch('Menu/setUserInfo', '');
            store.commit('Menu/updateToken', '');
            window.location.reload();
          }
        }
        return Promise.reject(error.response.data);
      }
      return Promise.reject(error.code);
    },
  );
  Vue.prototype.$service = service;
  request = service;
};

export { boot as default, request };
